// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4860":"c641d7ab","7853":"3effa04b"}[chunkId] + ".chunk.css";
};